module.exports = __webpack_public_path__ + "static/img/light.07a6736.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/feature6/light.png
// module id = adm0
// module chunks = 7